"use strict";

(function(z){

    z.SuppliersForm = z.FormView.extend({
        el:"#suppliersform-modal",

        events: function() {

            return _.extend({}, z.FormView.prototype.events,{
                "click #suppliersform-save-button": "_onSubmitForm",
            });
        },

        /**
         * Constructor.
         *
         * @return {undefined}
         */
        initialize: function() {

            z.FormView.prototype.initialize.apply(this, arguments);
        },

        /**
         * Method that renders the form
         *
         * @return {Object} - this object
         */
        render: function() {

            // Clean up the form
            this._cleanupForm();

            z.FormView.prototype.render.apply(this, arguments);

            var title = this.getModalFormEditTitleText();

            if (this.$el.find('.modal-title').text() === title) {

                this.$el.find("#suppliersform-sapSupplierId-field").prop("disabled", true);
                this.$el.find("#suppliersform-supplierSapType-field").prop("disabled", true);
            } else {

                this.$el.find("#suppliersform-sapSupplierId-field").prop("disabled", false);
                this.$el.find("#suppliersform-supplierSapType-field").prop("disabled", false);
            }
            // Initialize the chosen fields
            // this._initializeChosen();

            return this;
        },

        /**
         * Get add entity route name.
         *
         * @return {string} - add entity route name
         */
        getAddEntityRouteName: function() {
            return 'addSuppliers';
        },

        /**
         * Get edit entity route name.
         *
         * @return {string} - edit entity route name
         */
        getEditEntityRouteName: function() {
            return 'editSuppliers';
        },

        /**
         * Get modal form add title text
         *
         * @return {string} - modal form add title text
         */
        getModalFormAddTitleText: function() {
            return Translator.trans('js.btn_add_suppliers');
        },

        /**
         * Get modal form edit title text
         *
         * @return {string} - modal form edit title text
         */
        getModalFormEditTitleText: function() {
            return Translator.trans('js.btn_edit_suppliers');
        },

        /**
         * Get error panel container id.
         *
         * @return {string} - the error panel id
         */
        getErrorPanelId: function() {
            return '#suppliersform-error-panel';
        },

        /**
         * Get submit button selector.
         *
         * @return {string} - the submit button selector
         */
        getSubmitButtonSelector: function() {
            return '#suppliersform-save-button';
        },

        /**
         * Get page path.
         *
         * @return {string} - the page path
         */
        getPagePath: function() {
            return 'suppliers';
        },

        /**
         * Get success event name.
         *
         * @return {string} - the success event name
         */
        getSuccessEventName: function() {
            return 'suppliers.success';
        },

        /**
         * Get form error message text.
         *
         * @return {string} - form error message text
         */
        getFormErrorMessageText: function() {
            return Translator.trans('js.error_message_suppliersform');
        },


        /**
         * Collecting data from form inputs.
         *
         * @private
         * @return {Object} {{name: *, sapId: *, price: *, status: *}}
         */
        getFormData: function() {

            // Get the fields
            var $nameField     = this.$('#suppliersform-name-field');
            var $sapSupplierIdField   = this.$('#suppliersform-sapSupplierId-field');
            var $supplierSapTypeField   = this.$('#suppliersform-supplierSapType-field');
            var $statusField   = this.$('#suppliersform-status-field');

            return {
                'name'     : $nameField.val(),
                'sapSupplierId'   : $sapSupplierIdField.val(),
                'supplierSapType'   : $supplierSapTypeField.val(),
                'status'   : $statusField.val()
            };
        },

        /**
         * Method that resets the form fields, resets the collections and
         * hides the tables holding data
         *
         * @private
         * @return {undefined}
         */
        _cleanupForm: function() {

            // Resetting form
            this._resetFields("suppliersform");
        },

        /**
         * Method that hides the wrapper that holds the table
         *
         * @param {Object} $wrapperName - the div object that acts as a wrapper
         * @private
         * @return {undefined}
         */
        _hideWrapper: function($wrapperName) {

            $wrapperName.addClass("hidden");
        },


        /**
         * Method that resets the specified fields according to id passed
         *
         * @param {string} value Name of the id to search for
         * @private
         * @return {undefined}
         */
        _resetFields: function (value) {

            this.$('[id^=' + value + ']').val("");
        },


        // /**
        //  * Method that fills the form input fields with data coming from the model.
        //  * It is used when the form is being edited.
        //  *
        //  * @private
        //  * @return {undefined}
        //  */
        _fillForm: function() {

            // this._fillShowroomForm(this.model);

            var map = {
                "suppliersform-name-field": "name",
                "suppliersform-sapSupplierId-field": "sapSupplierId",
                "suppliersform-supplierSapType-field": "supplierSapType",
                "suppliersform-status-field": "status"
            };

            Object.keys(map).forEach(function(key){

                this.$el.find("#"+key).val(this.model.get(map[key]));

                var value = this.model.get(map[key]);
                switch (key) {

                    case "suppliersform-status-field":
                        if (value === true || value === 1) {
                            this.$("#" + key).val("1");
                        } else if(value === false || value === 0) {
                            this.$("#" + key).val("0");
                        } else {
                            this.$("#" + key).val("1");
                        }
                        break;

                    default:
                        this.$el.find("#" + key).val(value);
                }

            }.bind(this));
        },


        /**
         * Method that binds validation to the chosen model
         *
         * @param {object} model The model that the validation is being performend on
         * @private
         * @return {undefined}
         */
        _bindValidation: function(model) {

            model = _.isUndefined(model) ? this.model : model;
            Backbone.Validation.unbind(this, {model: model});

            Backbone.Validation.bind(this, {
                valid: this._onValid.bind(this),
                invalid: this._onInvalid.bind(this),
                model: model
            });
        },

        /**
         * Method that handles the form submission
         *
         * @param {Event} e - the event
         * @return {undefined}
         * @private
         */
        _onSubmitForm: function (e) {

            e.preventDefault();

            // Get form data
            var formData = this.getFormData();
            this.model.set(formData);

            var isValid = this.model.isValid(true);

            // Verify if the reseller model is valid
            if( !isValid ){
                this.showMobileAlert();
                return;
            }

            this._isLoading(true, this.getSubmitButtonSelector());

            this.model.save(null, {

                success: function (i) {

                    this.model.trigger("success", i);
                }.bind(this)
            });
        },
    });

})(window.z = window.z || {});
